import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './helpers/createBaseQuery';
import { IApplicationContext } from '../types/applicationContext';

import {
  fetchGetB2cSettings,
  TGetB2cSettingsResponse_1,
} from '../repositories/mortgage-broker-calculator/v1/get-b2c-settings';

export type TDictionariesApiEndpoits = keyof typeof dictionariesApi.endpoints;
export let dictionariesApi: ReturnType<typeof createDictionariesApi>;

export const createDictionariesApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'dictionariesApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getDictionaries: builder.query<TGetB2cSettingsResponse_1, void>({
        query: parameters => ({
          parameters,
          fetchFunction: fetchGetB2cSettings,
          loggerInfo: {
            description: 'Получение настроек лендинга',
            degradation: 'Критическая ошибка, недоступны словари банков и регионов',
          },
        }),
      }),
    }),
  });

  dictionariesApi = newApi;

  return newApi;
};
